// import axios from 'axios';
import axios from '../../utils/axiosConfig';

import { SALES_PAYMENT_LIST_REQUEST, SALES_PAYMENT_LIST_SUCCESS, SALES_PAYMENT_LIST_FAIL, SALES_PAYMENT_CREATE_REQUEST, SALES_PAYMENT_CREATE_SUCCESS, SALES_PAYMENT_CREATE_FAIL,   SALESPAYMENT_LIST_REQUEST,
  SALESPAYMENT_LIST_SUCCESS,
  SALESPAYMENT_LIST_FAIL, } from '../constants/salesPaymentConstants';

export const listSalesPayments = () => async (dispatch) => {
  try {
    dispatch({ type: SALES_PAYMENT_LIST_REQUEST });
    const { data } = await axios.get('/api/salesPayments');
    dispatch({ type: SALES_PAYMENT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SALES_PAYMENT_LIST_FAIL, payload: error.message });
  }
};

export const createSalesPayment = (salesPayment) => async (dispatch) => {
  try {
    dispatch({ type: SALES_PAYMENT_CREATE_REQUEST });
    // console.log("salespayment", salesPayment);
    const { data } = await axios.post('/api/salesPayments', salesPayment);
    // console.log("data", data);
    dispatch({ type: SALES_PAYMENT_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SALES_PAYMENT_CREATE_FAIL, payload: error.message });
  }
};

export const getSalesPaymentsByCaseId = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALES_PAYMENT_LIST_REQUEST });
    // console.log("id", id);
    const res = await axios.get(`/api/salesPayments/case/${id}`);
    // console.log("res", res);
    dispatch({ type: SALES_PAYMENT_LIST_SUCCESS, payload: res.data });
  } catch (error) {
    console.log("error", error);
    dispatch({ type: SALES_PAYMENT_LIST_FAIL, payload: error.message });
  }
};

export const getSalesPaymentDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: SALES_PAYMENT_LIST_REQUEST });
    const { data } = await axios.get(`/api/salesPayments/${id}`);
    dispatch({ type: SALES_PAYMENT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: SALES_PAYMENT_LIST_FAIL, payload: error.message });
  }
};

